import React, { useEffect, useMemo, useState } from "react";
import "./CartModal.css";
import { useDispatch } from "react-redux";
import { setItemToEdit, clearCart } from "../slices/cartSlice";
import { fetchItemDetails } from "../slices/itemSlice";
import useIsMobile from "../hooks/useIsMobile";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaymentModal from "./PaymentModal";
import ThankYouModal from "./ThankYouModal";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSettings } from "../context/SettingsContext";
import Swal from "sweetalert2";
import { getAddresses, addAddress } from "../slices/addressService";
import AddressAutocomplete from "./AddressAutocomplete";
  import { motion } from "framer-motion";

import { useModal } from "../context/ModalContext";
const CartModal = ({ openMenuModal,
  onClose,
  onViewFreeItem,
  ondeleteItem,
  isEligibleForFreeItem,
  isEligibleForFirstOrderOffer }) => {
  const [cartItems, setCartItems] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const dinein = JSON.parse(localStorage.getItem("dinein"));

  const [orderType, setOrderType] = useState(() => {
    if (dinein) return "dinein";
    return localStorage.getItem("orderType") || "";
  });
  const { openLogin, openRegister } = useModal();
  const [orderTiming, setOrderTiming] = useState(() => {
    if (dinein) return "now";
    return "";
  });



const DeleteTooltip = ({ onConfirm, onCancel }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -4, scale: 0.95 }}
      animate={{ opacity: 1, y: 6, scale: 1 }}
      exit={{ opacity: 0, y: -4, scale: 0.95 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="
        absolute right-0 top-full mt-2
        z-50
        bg-white border border-gray-200
        shadow-xl rounded-lg
        px-3 py-2
        w-36
      "
    >
      {/* Arrow */}
      <div className="absolute -top-2 right-3 w-3 h-3 bg-white border-l border-t border-gray-200 rotate-45"></div>

      <div className="text-xs text-gray-600 mb-2 text-center">
        Remove item?
      </div>

      <div className="flex gap-2">
        <button
          onClick={onConfirm}
          className="
            flex-1 bg-red-600 text-white
            text-xs py-1.5 rounded
            hover:bg-red-700 transition
          "
        >
          Delete
        </button>

        <button
          onClick={onCancel}
          className="
            flex-1 bg-gray-100 text-gray-700
            text-xs py-1.5 rounded
            hover:bg-gray-200 transition
          "
        >
          Cancel
        </button>
      </div>
    </motion.div>
  );
};

   const [deliveryelegible, setDeliveryelegible] = useState(false);

    const [deliveryelegiblemessage, setDeliveryelegibleMessage] = useState(false);


    const [zipcodes, setZipCodes] = useState([]);
  const [scheduleDate, setScheduleDate] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [readyText, setReadyText] = useState("");
  const [externalDeliveryId, SetExternalDeliveryId] = useState("");
  const [tips, setTips] = useState([]);          // list from API
  const [selectedTip, setSelectedTip] = useState(null); // user's selection
  const [editingAddress, setEditingAddress] = useState(null);
const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  const [refreshAddress, setRefreshAddress] = useState(null);

// Always round to 2 decimals safely
const round2 = (num) => {
  return Number(Number(num || 0).toFixed(2));
};

  const [paymentType, setPaymentType] = useState(""); // default cash

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [thankYouData, setThankYouData] = useState(null);
  const [paymentOrderId, setPaymentOrderId] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const { settings, loading } = useSettings();
  const navigate = useNavigate();

  useEffect(() => {
  if (!settings) return;

  // Skip if dine-in
  if (orderType === "dinein") return;

  const availableTypes = [];

  // Delivery enabled
  if (settings?.is_delivery_off == 1) {
    availableTypes.push("delivery");
  }

  // Pickup is always available in your UI
  availableTypes.push("pickup");

  // If ONLY one option available → auto select it
  if (availableTypes.length === 1) {
    setOrderType(availableTypes[0]);
  }

}, [settings]);

  const [userRewards, setUserRewards] = useState(0);   // from API
  const [redeemPoints, setRedeemPoints] = useState(""); // user input
  const [appliedRewards, setAppliedRewards] = useState(null);

  // 🔥 Address management
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState("");
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [newAddress, setNewAddress] = useState({
    hno: "",
    street_address: "",
    suburb: "",
    pincode: "",
    city: "",
    state: "",
    country: "AU",
  });

  const handleApplyRewards = () => {
    if (!settings?.is_rewards || settings.is_rewards != "1") {
      toast.error("❌ Rewards not enabled.");
      return;
    }

    if (subtotal < Number(settings.rewards_redeem_min_order || 0)) {
      toast.error(`❌ Minimum order subtotal should be ${localStorage.getItem('currency')} ${settings.rewards_redeem_min_order} to use rewards.`);
      return;
    }

    var rewards_redeem_per = round2(settings.rewards_redeem_per);
    if (rewards_redeem_per > 0) {
      rewards_redeem_per = (subtotal * rewards_redeem_per) / 100;
    }




    const points = round2(redeemPoints) || 0;
    if (points <= 0) {
      toast.error("❌ Please enter valid points.");
      return;
    }

    if (userRewards < round2(settings.rewards_redeem_min)) {
      toast.error(`❌ You have to minimum redeem rewards ${settings.rewards_redeem_min} to apply .`);
      return;
    }




    if (points > round2(settings.rewards_redeem_max)) {
      toast.error(`❌ Limit of maximum redeem rewards ${settings.rewards_redeem_max} .`);
      return;
    }

    if (points > userRewards) {
      toast.error("❌ You don’t have that many reward points.");
      return;
    }


    

    // conversion → rewards_point_value / rewards_point
    const pointValue = round2(settings.rewards_point_value) / round2(settings.rewards_point);
    const valueRedeemed = points * pointValue;


    if (valueRedeemed > rewards_redeem_per) {
      toast.error(`❌ Limit of maximum redeem rewards value  ${rewards_redeem_per} .`);
      return;
    }

    setAppliedRewards({ points, value: valueRedeemed });
    toast.success(`✅ ${points} points applied (-${localStorage.getItem('currency')}${valueRedeemed.toFixed(2)})`);
  };

  const handleRemoveRewards = () => {
    setAppliedRewards(null);
    setRedeemPoints("");
    toast.info("⚠️ Rewards removed.");
  };


  // At the top of your component
  const [deviceId, setDeviceId] = useState(() => {
    let id = localStorage.getItem("deviceId");
    if (!id) {
      id = `device_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
      localStorage.setItem("deviceId", id);
    }
    return id;
  });


  const {token, user} = useSelector((state) => state.auth); // get from Redux
const [guestName, setGuestName] = useState(() => {
  return localStorage.getItem("guestName") || "";
});

const [guestEmail, setGuestEmail] = useState(() => {
  return localStorage.getItem("guestEmail") || "";
});

const [guestPhone, setGuestPhone] = useState(() => {
  return localStorage.getItem("guestPhone") || "";
});



useEffect(() => {
  localStorage.setItem("guestName", guestName);
}, [guestName]);

useEffect(() => {
  localStorage.setItem("guestEmail", guestEmail);
}, [guestEmail]);

useEffect(() => {
  localStorage.setItem("guestPhone", guestPhone);
}, [guestPhone]);

  // validate email format
  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const [specialInstruction, setSpecialInstruction] = useState(() => {
    return localStorage.getItem("specialInstruction") || "";
  });

  useEffect(() => {
    if (!settings) return;

    if (orderType === "delivery") {
      const hasCash = settings.is_cash_on_delivery == "1";
      const hasCard = settings.is_payment_gateway == "1";

      if (hasCash && !hasCard) setPaymentType("cash");
      else if (!hasCash && hasCard) setPaymentType("card");
      else if (!hasCash && !hasCard) setPaymentType(""); // no option
    }

    if (orderType === "pickup") {
      const hasCash = settings.is_cash_on_collection == "1";
      const hasCard = settings.is_payment_gateway == "1";

      if (hasCash && !hasCard) setPaymentType("cashoncollection");
      else if (!hasCash && hasCard) setPaymentType("card");
      else if (!hasCash && !hasCard) setPaymentType(""); // no option
    }
  }, [orderType, settings]);

  useEffect(() => {
  if (!scheduleDate) return;

  const todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0);

  const selectedDate = new Date(scheduleDate);
  selectedDate.setHours(0, 0, 0, 0);

  if (selectedDate < todayDate) {
    const newToday = todayDate.toISOString().split("T")[0];

    setScheduleDate(newToday);
    setScheduleTime("");

    localStorage.setItem("scheduleDate", newToday);
    localStorage.removeItem("scheduleTime");

    toast.info("Selected date was in the past. Reset to today.");
  }
}, []);


  const availablePaymentTypes = useMemo(() => {
    if (!settings) return [];

    if (orderType === "delivery") {
      return [
        settings.is_cash_on_delivery == "1" && "cash",
        settings.is_payment_gateway == "1" && "card",
      ].filter(Boolean);
    }

    if (orderType === "pickup") {
      return [
        settings.is_cash_on_collection == "1" && "cashoncollection",
        settings.is_payment_gateway == "1" && "card",
      ].filter(Boolean);
    }

    if (orderType === "dinein") {
      return [
        settings.dinein_cash == "1" && "cash",
        settings.is_payment_gateway == "1" && "card",
      ].filter(Boolean);
    }

    return [];
  }, [orderType, settings]);
  useEffect(() => {
    if (availablePaymentTypes.length === 1) {
      setPaymentType(availablePaymentTypes[0]);
    } else if (availablePaymentTypes.length === 0) {
      setPaymentType(""); // none available
    } else {
      setPaymentType(""); // force user to pick
    }
  }, [availablePaymentTypes]);
   const loadAddressesFromDB = async () => {
  try {
    const res = await getAddresses(token);
    if (res.data.success) {
      setAddresses(res.data.data || []);
    }
  } catch (e) {
   
  }
};


useEffect(() => {
  if (user?.id && token) {
    loadAddressesFromDB();
  } else {
    const local = localStorage.getItem("addresses");
    setAddresses(local ? JSON.parse(local) : []);
  }
}, [user, token]);

  // ⬇️ load persisted values on first render
useEffect(() => {
  const savedOrderType = localStorage.getItem("orderType");
  const savedOrderTiming = localStorage.getItem("orderTiming");
  const savedScheduleDate = localStorage.getItem("scheduleDate");
  const savedScheduleTime = localStorage.getItem("scheduleTime");
  const savedAddresses = localStorage.getItem("addresses");
  const savedSelectedAddressId = localStorage.getItem("selectedAddressId");

  if (savedOrderType) {
    setOrderType(savedOrderType);
  }

  // ✅ Default to "now" if not saved
  if (savedOrderTiming) {
    setOrderTiming(savedOrderTiming);
  } else {
    setOrderTiming("now");
    localStorage.setItem("orderTiming", "now");
  }

  if (savedScheduleDate) {
    setScheduleDate(savedScheduleDate);
  }

  if (savedScheduleTime) {
    setScheduleTime(savedScheduleTime);
  }

  if (savedAddresses) {
    setAddresses(JSON.parse(savedAddresses));
  }

  if (savedSelectedAddressId) {
    setSelectedAddressId(savedSelectedAddressId);
  }
}, []);

  // new states for coupons & vouchers
  const [couponCode, setCouponCode] = useState(localStorage.getItem("couponCode") || "");
  const [giftVoucherCode, setGiftVoucherCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  // allow multiple vouchers → keep an array of voucher objects
  // voucher object shape used here: { id, code, original_amount, remaining_amount, applied_amount }
  const [appliedVouchers, setAppliedVouchers] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("appliedVouchers")) || [];
    } catch (e) {
      return [];
    }
  });

  // handle apply coupon
  const handleApplyCoupon = async () => {

    if (grandTotal === 0) {
      toast.error("❌ Cannot apply coupon — total is already zero.");
      return;
    }


    if (!couponCode) {
      toast.error("❌ Please enter a coupon code.");
      return;
    }

    try {
      const payload = {user: user || null,  promo: couponCode, subtotal:subtotal_coupon_allowed, orderType };
      const { data } = await axios.post(
        `${window.BASE_API_URL}apply-coupon`,
        payload
      );

      if (data?.id) {
        setAppliedCoupon(data);
        localStorage.setItem("couponCode", couponCode);
        toast.success("✅ Coupon applied successfully!");
      } else {
        toast.error(data?.message || "❌ Invalid coupon code.");
      }
    } catch (err) {
      console.error(err);
      toast.error("❌ Failed to apply coupon.");
    }
  };

  const today = new Date().toISOString().split("T")[0];

  // Create a copy of today's date for max calculation
  const maxDateObj = new Date();
  maxDateObj.setDate(maxDateObj.getDate() + (settings?.delivery_day || 0));

  const maxDate = maxDateObj.toISOString().split("T")[0];

  // remove coupon
  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode("");
    localStorage.removeItem("couponCode");
    toast.info("⚠️ Coupon removed.");
  };

  const minimumOrderValue = useMemo(() => {
    // console.log(settings);
    if (!settings) return 0;
    if (orderType == 'dinein') return 0;
    return orderType === "pickup"
      ? Number(settings.min_order_pickup || 0)
      : Number(settings.min_order || 0);
  }, [settings, orderType]);

  // handle apply voucher - supports multiple vouchers and partial usage
  const handleApplyVoucher = async () => {

    if (grandTotal === 0) {
      toast.error("❌ Cannot apply voucher — total is already zero.");
      return;
    }
    if (!giftVoucherCode) {
      toast.error("❌ Please enter a voucher code.");
      return;
    }

    const alreadyExists = appliedVouchers.some(
      (v) => v.code.toLowerCase() === giftVoucherCode.toLowerCase()
    );
    if (alreadyExists) {
      toast.error("❌ This voucher is already applied.");
      return;
    }

    try {
      // send subtotal to backend so it can validate voucher and return amount info
      const payload = { voucher: giftVoucherCode, subtotal, orderType };
      const { data } = await axios.post(
        `${window.BASE_API_URL}apply-voucher`,
        payload
      );

      // expected backend response: { success: true, data: { id, code, amount } }
      if (data?.success && data.data) {
        const serverVoucher = data.data;
        const originalAmount = parseFloat(serverVoucher.amount) || 0;

        // compute payable amount before vouchers
        const payableBeforeVouchers = Number((subtotal_before_discount + taxTotal + additionalTotal - discountTotal - couponTotal).toFixed(2));
        const alreadyUsed = appliedVouchers.reduce((s, v) => s + (parseFloat(v.applied_amount) || 0), 0);
        const remainingPayable = Math.max(0, payableBeforeVouchers - alreadyUsed);

        const appliedAmount = Math.min(originalAmount, remainingPayable);
        const remaining_amount = Math.max(0, originalAmount - appliedAmount);

        const voucherObj = {
          id: serverVoucher.id ?? serverVoucher.code ?? Date.now(),
          code: serverVoucher.code ?? giftVoucherCode,
          name: serverVoucher.name ?? 'Gift Voucher',
          original_amount: Number(originalAmount.toFixed(2)),
          applied_amount: Number(appliedAmount.toFixed(2)),
          remaining_amount: Number(remaining_amount.toFixed(2)),
        };

        // push into list
        const next = [...appliedVouchers, voucherObj];
        setAppliedVouchers(next);
        localStorage.setItem("appliedVouchers", JSON.stringify(next));
        setGiftVoucherCode("");
        toast.success(`✅ Voucher ${voucherObj.code} applied: - ${localStorage.getItem('currency')} ${voucherObj.applied_amount}`);

      } else {
        toast.error(data?.message || "❌ Invalid voucher code.");
      }
    } catch (err) {
      console.error(err);
      toast.error("❌ Failed to apply voucher.");
    }
  };

  const handleRemoveVoucher = (codeOrId) => {
    const next = appliedVouchers.filter(v => v.id !== codeOrId && v.code !== codeOrId);
    setAppliedVouchers(next);
    localStorage.setItem("appliedVouchers", JSON.stringify(next));
    toast.info("⚠️ Voucher removed.");
  };

  const handlePaymentSuccess = ({ orderId, orderNo }) => {
    setShowPaymentModal(false);
    onClose();
    dispatch(clearCart());
    localStorage.removeItem("cart");
    setCartItems([]);

    localStorage.removeItem("guestName");
localStorage.removeItem("guestEmail");
localStorage.removeItem("guestPhone");

setGuestName("");
setGuestEmail("");
setGuestPhone("");
    // ✅ Navigate to Thank You page
    navigate("/thank-you?orderId=" + orderId);
  };

  // Keep CartModal state in sync with localStorage
  useEffect(() => {
    localStorage.setItem("orderType", orderType);
  }, [orderType]);

  useEffect(() => {
    localStorage.setItem("orderTiming", orderTiming);
  }, [orderTiming]);

  useEffect(() => {
    localStorage.setItem("scheduleDate", scheduleDate);
  }, [scheduleDate]);

  useEffect(() => {
    localStorage.setItem("scheduleTime", scheduleTime);
  }, [scheduleTime]);

  useEffect(() => {
    localStorage.setItem("addresses", JSON.stringify(addresses));
  }, [addresses]);

  useEffect(() => {
    if (selectedAddressId) {
      localStorage.setItem("selectedAddressId", selectedAddressId);
    }
  }, [selectedAddressId]);

  // 🔹 Add new state
  const [timeSlots, setTimeSlots] = useState([]);

  // 🔹 Utility: convert yyyy-mm-dd → dd-mm-yyyy
  const formatDateDMY = (dateStr) => {
    if (!dateStr) return "";
    const [y, m, d] = dateStr.split("-");
    return `${d}-${m}-${y}`;
  };

  // 🔹 Fetch slots API
  const fetchTimeSlots = async (date, type) => {
    try {
      const payload = {
        date: formatDateDMY(date),
        deliver_type: type === "delivery" ? "0" : "1",
        hasCustomPrep
      };
      const { data } = await axios.post(
        `${window.BASE_API_URL}gettimes`,
        payload
      );
      if (Array.isArray(data)) {
        setTimeSlots(data);
      } else {
        setTimeSlots([]);
      }
    } catch (err) {
      console.error("Failed to fetch time slots:", err);
      setTimeSlots([]);
    }
  };

  useEffect(() => {
    localStorage.setItem("specialInstruction", specialInstruction);
  }, [specialInstruction]);

  // 🔹 Watch for date/orderType changes
  useEffect(() => {
    if (orderTiming === "later" && scheduleDate) {
      fetchTimeSlots(scheduleDate, orderType);
    } else {
      setTimeSlots([]);
    }
  }, [scheduleDate, orderType, orderTiming]);

  // Charges from API
  const [charges, setCharges] = useState({ tax: [], additional: [], special: [] });

  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const cartData = JSON.parse(localStorage.getItem("cart")) || [];


  // console.log(cartData);

  const hasCustomPrep = cartData.some(ci => ci.type == "custom_prep_time");
  useEffect(() => {
    loadCart();
  }, []);

  const loadCart = () => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(storedCart);
  };

  const toggleAccordion = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const deleteItem = async (id) => {
    // // 🧠 Confirmation Alert
    // const result = await Swal.fire({
    //   title: "Remove item?",
    //   text: "Are you sure you want to delete this item from your cart?",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonText: "Yes, remove it",
    //   cancelButtonText: "Cancel",
    //   confirmButtonColor: "#d33",
    //   cancelButtonColor: "#3085d6",
    // });

    // if (!result.isConfirmed) {
    //   toast.info("🛒 Item removal cancelled.");
    //   return;
    // }

    const updatedCart = cartItems.filter((item) => item.id !== id);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCartItems(updatedCart);
    if (updatedCart.length === 0) {
      localStorage.removeItem("cartCreatedAt");
    }


    toast.success("🗑️ Item removed from cart!");

    // 🔥 Check free item eligibility after deletion
    if (!settings) return;

    const freeMenuIds = Array.isArray(settings.free_menu_id)
      ? settings.free_menu_id.map(String) // ensure string comparison
      : [];

    const freeItemAmount = Number(settings.freeitem_amount || 0);

    // ✅ Calculate subtotal excluding free items
    const subtotalWithoutFree = updatedCart.reduce((sum, item) => {
      const isFree =
        freeMenuIds.includes(String(item.itemId)) ||
        String(item.itemId)?.startsWith("free_");
      return isFree ? sum : sum + (parseFloat(item.total) || 0);
    }, 0);

    // ✅ If subtotal drops below threshold, remove free items
    if (subtotalWithoutFree < freeItemAmount && freeMenuIds.length > 0) {
      const filteredCart = updatedCart.filter(
        (item) =>
          !freeMenuIds.includes(String(item.itemId)) &&
          !String(item.itemId)?.startsWith("free_")
      );

      if (filteredCart.length !== updatedCart.length) {
        localStorage.setItem("cart", JSON.stringify(filteredCart));
        setCartItems(filteredCart);
        ondeleteItem();
        toast.info(
          "⚠️ Offer item(s) removed because you are no longer eligible for the offer."
        );
      }
    }
  };



  const handleEdit = (item) => {
    if (item.type === "combo") {
      const { fetchComboDetails } = require("../slices/comboSlice");
      dispatch(fetchComboDetails(item.comboId || item.combo_id));
      localStorage.setItem("editComboItem", JSON.stringify(item));
      onClose();
      window.dispatchEvent(new Event("openComboEditor"));
    } else {
      dispatch(fetchItemDetails(item.itemId));
      openMenuModal();
      dispatch(setItemToEdit(item));
      onClose();
    }
  };


  // ✅ Subtotal (numeric)
  // const subtotal = useMemo(
  //   () =>
  //     cartItems.reduce((sum, item) => {
  //       const t = typeof item.total === "number" ? item.total : parseFloat(item.total) || 0;
  //       return sum + t;
  //     }, 0),
  //   [cartItems]
  // );

  // First calculate subtotal BEFORE discount
const subtotal_before_discount = useMemo(
  () => round2(cartItems.reduce((sum, item) => {
      const t = round2(item.total);
      return sum + t;
  }, 0)),
  [cartItems]
);


// Total where Coupon IS allowed  
const subtotal_coupon_allowed = useMemo(() => {
  return round2(
    cartItems.reduce((sum, item) => {
      const t = Number(item.total) || 0;
      if (item.exclusion?.includes("Coupan")) return sum;  // exclude
      return sum + t;
    }, 0)
  );
}, [cartItems]);



// Total where Special Discount IS allowed  
const subtotal_special_allowed = useMemo(() => {
  return round2(
    cartItems.reduce((sum, item) => {
      const t = Number(item.total) || 0;
      if (item.exclusion?.includes("SpecialDiscount")) return sum;
      return sum + t;
    }, 0)
  );
}, [cartItems]);



const calcDiscountAmount = (s) => {
  const disc = parseFloat(s.discount) || 0;
  if (s.discount_type === "P") return round2((subtotal_special_allowed * disc) / 100);
  return round2(disc);
};

const calcCouponAmount = (c) => {
  if (!c) return 0;
  const disc = parseFloat(c.discount) || 0;
  if (c.discount_type === "P") return round2((subtotal_coupon_allowed * disc) / 100);
  return round2(disc);
};


  const couponTotal = useMemo(() => calcCouponAmount(appliedCoupon), 
  [appliedCoupon, subtotal_before_discount]
);

const discountTotal = useMemo(() => 
  (charges.special || []).reduce((sum, s) => sum + calcDiscountAmount(s), 0),
  [charges.special, subtotal_before_discount]
);

const subtotal = round2(
  subtotal_before_discount - couponTotal - discountTotal
);

useEffect(() => {
  const fetchZipcodes = async () => {
    try {
      const { data } = await axios.get(`${window.BASE_API_URL}getZipcode`);
      setZipCodes(data);
    } catch (err) {
      console.error("Failed to fetch zipcodes:", err);
    }
  };

  fetchZipcodes();
}, []); // ✅ Run only once when component mounts




  useEffect(() => {
    const order_status = async () => {
      try {



        const payload = {
          tableId: dinein?.tableId,
          hasCustomPrep: hasCustomPrep,
          type: orderType,
          timing: orderTiming,
          scheduleDate: orderTiming === "later" ? scheduleDate : null,
          scheduleTime: orderTiming === "later" ? scheduleTime : null,
        };
        const { data } = await axios.post(
          `${window.BASE_API_URL}order_status`,
          payload
        );

        if (data?.success == false) {

          setOrderStatus(data?.message);
        } else {
          setOrderStatus('');

        }
      } catch (err) {
        console.error("Failed to fetch charges:", err);

      }
    };

    order_status();
  }, [orderType, orderTiming, scheduleTime, scheduleDate]);



  useEffect(() => {
    const preptime = async () => {
      try {
        const payload = {
          hasCustomPrep: hasCustomPrep,
          orderType
        };
        const { data } = await axios.post(
          `${window.BASE_API_URL}order_prep`,
          payload
        );

        if (data) {

          setReadyText(data);
        } else {
          setReadyText('');

        }
      } catch (err) {
        console.error("Failed to fetch charges:", err);

      }
    };

    preptime();
  }, [orderType]);
  useEffect(() => {
    const fetchCharges = async () => {
      try {

        var phone = '';
        if(user?.id)
        {
          phone = user?.phone;
        } else {
          phone = guestPhone;
        }

        var pt = paymentType;

        if(paymentType == 'cashoncollection')
        {
          pt = 'cash';
        }
        const payload = {
          delivery_type: orderType, subtotal, paymentType: pt, appliedCoupon,subtotal_before_discount,

          userId: user?.id || null, subtotal_special_allowed,
          address: orderType === "delivery" ? addresses.find((a) => a.id === selectedAddressId) : null,
          phone,

          type: orderType,
          timing: orderTiming,
          scheduleDate: orderTiming === "later" ? scheduleDate : null,
          scheduleTime: orderTiming === "later" ? scheduleTime : null,


        };
        const { data } = await axios.post(
          `${window.BASE_API_URL}getCartAppliedData`,
          payload
        );

        if (data?.success && data?.data) {
          const { tax = [], additional = [], special = [], tips = [], rewards = 0 } = data.data || {};
          setCharges({ tax, additional, special });
          setTips(tips); 
          setUserRewards(Number(rewards).toFixed(2) || 0);
          setDeliveryelegible(data?.data?.deliveryelegible);
          setDeliveryelegibleMessage(data?.data?.deliveryelegiblemessage);
          SetExternalDeliveryId(data?.data?.external_delivery_id);
          
        } else {
          setCharges({ tax: [], additional: [], special: [] });
          setTips([]);
          setUserRewards(0);
          setDeliveryelegible(false);
          setDeliveryelegibleMessage("");
          SetExternalDeliveryId("");
        }
      } catch (err) {
        console.error("Failed to fetch charges:", err);
        setCharges({ tax: [], additional: [], special: [] });
        setTips([]);
      }
    };

    if (subtotal > 0) {
      fetchCharges();
    } else {
      setCharges({ tax: [], additional: [], special: [] });
      setTips([]);
    }
  }, [subtotal_before_discount, orderType, paymentType, selectedAddressId, appliedCoupon, orderTiming, scheduleDate, refreshAddress]);

  // 💡 Helpers to compute amounts
const calcTaxAmount = (t) =>
  round2((subtotal * (parseFloat(t.tax) || 0)) / 100);

const calcAdditionalAmount = (a) => {
  const charge = parseFloat(a.charge) || 0;
  const fixed = parseFloat(a.fixed_amount) || 0;

  if (a.type === "P") return round2((subtotal * charge) / 100);
  if (a.type === "B") return round2((subtotal * charge) / 100 + fixed);

  return round2(charge);
};




  // 🧮 Totals
  const taxTotal = useMemo(
    () => (charges.tax || []).reduce((sum, t) => sum + calcTaxAmount(t), 0),
    [charges.tax, subtotal]
  );

  const additionalTotal = useMemo(
    () => (charges.additional || []).reduce((sum, a) => sum + calcAdditionalAmount(a), 0),
    [charges.additional, subtotal]
  );

  // const discountTotal = useMemo(
  //   () => (charges.special || []).reduce((sum, s) => sum + calcDiscountAmount(s), 0),
  //   [charges.special, subtotal]
  // );

  // const couponTotal = useMemo(() => calcCouponAmount(appliedCoupon, subtotal), [appliedCoupon, subtotal]);

  // total covered by vouchers (sum of applied_amount)
  const voucherTotal = useMemo(() => {
    return round2(
  appliedVouchers.reduce((s, v) => s + round2(v.applied_amount), 0)
);

  }, [appliedVouchers]);


const tipAmount = useMemo(() => {
  if (!selectedTip) return 0;

  if (selectedTip.type === "F") return round2(selectedTip.amount);
  if (selectedTip.type === "P") return round2((subtotal * selectedTip.amount) / 100);

  return 0;
}, [selectedTip, subtotal]);


  const rewardTotal = appliedRewards?.value || 0;

  const isInclusiveTax = settings?.tax_type == 1;
const taxRate = Number(settings?.tax_value || 0);


const inclusiveTaxAmount = useMemo(() => {
  if (!isInclusiveTax || taxRate <= 0) return 0;
  return round2(subtotal - subtotal / (1 + taxRate / 100));
}, [subtotal,
    taxTotal,
    additionalTotal,
    voucherTotal,
    rewardTotal,
    tipAmount,
    isInclusiveTax]);

const finalTaxTotal = isInclusiveTax ? inclusiveTaxAmount : taxTotal;


const grandTotal = useMemo(
  () =>
    round2(
      subtotal +
      (isInclusiveTax ? 0 : taxTotal) +
      additionalTotal -
      voucherTotal -
      rewardTotal +
      tipAmount
    ),
  [
    subtotal,
    taxTotal,
    additionalTotal,
    voucherTotal,
    rewardTotal,
    tipAmount,
    isInclusiveTax,
  ]
);



  // console.log(subtotal , taxTotal , additionalTotal , discountTotal , couponTotal , voucherTotal , rewardTotal , tipAmount);

const handleAddAddress = async () => {
 if (settings?.delivery_type == 1) {

    if (!newAddress.street_address) {
      toast.error("❌ Please select a delivery address.");
      return;
    }

  } else {
    // 🔥 Normal manual address validation
    if (
      !newAddress.hno ||
      !newAddress.street_address ||
      !newAddress.pincode ||
      !newAddress.state
    ) {
      toast.error("❌ Please fill all required fields.");
      return;
    }
  }
  try {
    if (editingAddress) {
      // ---------- UPDATE ----------
      const updated = { ...newAddress, token };

      if (user?.id && token) {
        let res = await axios.post(`${window.BASE_API_URL}address/update`, updated);

        if (!res.data.success) {
          toast.error(res.data.message);
          return;
        }

        await loadAddressesFromDB();
      } else {
        // update in localStorage
        const updatedList = addresses.map(a => a.id === editingAddress.id ? updated : a);
        setAddresses(updatedList);
        localStorage.setItem("addresses", JSON.stringify(updatedList));
      }

  setRefreshAddress(updated);
      toast.success("✅ Address updated!");
      setEditingAddress(null);
    } 
    
    else {
      // ---------- ADD ----------
      const newAddr = {
        id: Date.now(),
        ...newAddress,
        addedAt: new Date().toLocaleString(),
      };

      if (user?.id && token) {
        let res = await addAddress({ ...newAddr, token });
        if (res?.data?.success === false) {
          toast.error(res?.data?.message);
          return;
        }
        await loadAddressesFromDB();
      } else {
        const updated = [...addresses, newAddr];
        setAddresses(updated);
        localStorage.setItem("addresses", JSON.stringify(updated));
      }

      toast.success("✅ Address added successfully!");
    }

    // Reset modal
    setNewAddress({
      hno: "",
      street_address: "",
      suburb: "",
      pincode: "",
      city: "",
      state: "",
      country: "AU",
    });

    setShowAddressPopup(false);
  } catch (err) {
    console.error(err);
    toast.error("❌ Failed to save address");
  }
};



useEffect(() => {
  if (user?.id && token) syncLocalAddressesToDB();
}, [user]);

  const syncLocalAddressesToDB = async () => {
  const local = JSON.parse(localStorage.getItem("addresses") || "[]");
  if (local.length && user?.id && token) {
    for (let addr of local) {
      await addAddress({ ...addr, token });
    }
    localStorage.removeItem("addresses");
    loadAddressesFromDB();
  }
};

useEffect(() => {
  if (addresses.length === 1) {
    setSelectedAddressId(addresses[0].id);
  }
}, [addresses]);


  // 🛒 Place Order → API call with validation
  const handlePlaceOrder = async () => {

   

    if (subtotal < minimumOrderValue) {
      toast.error(`❌ Minimum order value for ${orderType} is $${minimumOrderValue}`);
      return;
    }

    if (orderType === "delivery") {

      

      if (settings?.is_delivery_off == 0) {
        toast.error("❌ Delivery is off for now, please try later.");
        return;
      }
      let add = addresses.find((a) => a.id === selectedAddressId);

if (!add) {
  toast.error("❌ Please select or add a delivery address before placing the order.");
  return;
}

if (settings?.delivery_type == 0) {
  const isDeliverable = zipcodes.includes(add.pincode?.toString()); // ✅ use add, ensure string
  if (!isDeliverable) {
    toast.error("❌ Delivery is not possible in the selected delivery area.");
    return;
  }
}


if(settings?.deliver_type == 3)
{
  if(!externalDeliveryId)
  {
        toast.error("❌ Enable to find your address on uber eats, contact to restaurant");
    return;
  }
}


 if(deliveryelegible != true)
    {
      toast.error(`❌ Delivery is not possible in the selected delivery area. `);
      return;

    }
          
    }

    // ✅ Mandatory Date & Time if Scheduled Later

    if (orderType != 'dinein' && (orderTiming === "later" && (!scheduleDate || !scheduleTime))) {
      toast.error("❌ Please select both date and time for scheduled order.");
      return;
    }

    if (orderType != 'dinein' && !orderTiming) {
      toast.error("❌ Please select both date and time for scheduled order.");
      return;
    }

    var finalUser = user;

    // If not logged in → guest checkout validation
    if (!user) {
       finalUser = user;

// Dine-in special logic
if (orderType === "dinein") {
  
  // CASE 1 → No info required
  if (settings?.user_dinein_info == 1) {
    finalUser = {
      name: "anonymous",
      email: "anonymous",
      phone: "0000000000",
      type: "guest",
    };
  }

  // CASE 2 → Only Name required
  else if (settings?.user_dinein_info == 2) {
    if (!guestName) {
      toast.error("❌ Please enter your name");
      return;
    }
    finalUser = {
      name: guestName,
      email: "anonymous",
      phone: "0000000000",
      type: "guest",
    };
  }

  // CASE 0 → All three mandatory
  else if (settings?.user_dinein_info == 0) {
    if (!guestName || !guestEmail || !guestPhone) {
      toast.error("❌ Please fill Name, Email and Phone");
      return;
    }
    if (!validateEmail(guestEmail)) {
      toast.error("❌ Invalid email format");
      return;
    }
    if (guestPhone.length < 8) {
      toast.error("❌ Phone number must be at least 8 digits");
      return;
    }

    finalUser = {
      name: guestName,
      email: guestEmail,
      phone: guestPhone,
      type: "guest",
    };
  }
}

// Non-dinein guest checkout (existing logic)
else if (!user) {
  if (!guestName || !guestEmail || !guestPhone) {
    toast.error("❌ Please fill Name, Email and Phone");
    return;
  }
  if (!validateEmail(guestEmail)) {
    toast.error("❌ Invalid email format");
    return;
  }
  if (guestPhone.length < 8) {
    toast.error("❌ Phone number must be at least 8 digits");
    return;
  }

  finalUser = {
    name: guestName,
    email: guestEmail,
    phone: guestPhone,
    type: "guest",
  };
}

    }

    const orderData = {
     tax_type: settings?.tax_type,
      tax_label: isInclusiveTax ? settings?.tax_label : "",
      tax_value: isInclusiveTax ? settings?.tax_value : "",
      tax_amount: round2(finalTaxTotal),
      externalDeliveryId,
      user: finalUser,
      type: orderType,
      timing: orderTiming,
      scheduleDate: orderTiming === "later" ? scheduleDate : null,
      scheduleTime: orderTiming === "later" ? scheduleTime : null,
      address: orderType === "delivery" ? addresses.find((a) => a.id === selectedAddressId) : null,
      items: cartItems,
      special_instruction: specialInstruction || "",

      // 🧾 Price breakdown
      subtotal: round2(subtotal_before_discount),
      subtotal_before_discount: round2(subtotal_before_discount),
      subtotal_after_discount: round2(subtotal),
      tax_total: round2(taxTotal.toFixed(2)),
      additional_total: round2(additionalTotal),
      discount_total: round2(discountTotal),
      coupon_total: round2(couponTotal),
      voucher_total: round2(voucherTotal),
      total: round2(grandTotal),

      // Optional: raw lines if your backend wants details
      tax_lines: (charges.tax || []).map((t) => ({
        id: t.id,
        label: t.label ?? "Tax",
        rate: parseFloat(t.tax) || 0,
        amount: round2(calcTaxAmount(t)),
      })),
      additional_lines: (charges.additional || []).map((a) => ({
        id: a.id,
        label: a.label ?? "Additional",
        type: a.type === "B" ? "F" : a.type, // convert B → F
        value: a.type === "B" ? Number(calcAdditionalAmount(a).toFixed(2)) : parseFloat(a.charge) || 0,
        amount: Number(calcAdditionalAmount(a).toFixed(2)),
      })),

      discount_lines: (charges.special || []).map((s) => ({
        id: s.id,
        label: s.label ?? "Special Discount",
        type: s.discount_type, // F | P
        value: parseFloat(s.discount) || 0,
        amount: Number(calcDiscountAmount(s).toFixed(2)),
      })),

      coupon_lines: appliedCoupon
        ? [
          {
            id: appliedCoupon.id,
            code: appliedCoupon.promo_code,
            type: appliedCoupon.discount_type,
            value: parseFloat(appliedCoupon.discount) || 0,
            amount: Number(couponTotal.toFixed(2)),
          },
        ]
        : [],

      voucher_lines: appliedVouchers.map((v) => ({
        id: v.id,
        code: v.code,
        name: v.name,
        original_amount: Number(v.original_amount),
        applied_amount: Number(v.applied_amount),
        remaining_amount: Number(v.remaining_amount),
      })),
      deviceId,
      hasCustomPrep,
      subtotal_coupon_allowed,
      subtotal_special_allowed,
      addtime: readyText,
      tip: selectedTip ? {
        type: selectedTip.type,
        value: selectedTip.amount,
        amount: tipAmount
      } : null,

      rewards: appliedRewards
        ? {
          points: appliedRewards.points,
          value: Number(appliedRewards.value.toFixed(2)),
        }
        : null,

    };

    if (orderType === "dinein" && dinein) {
      orderData.tableId = dinein.tableId || dinein.id || null;
      orderData.tableName = dinein.tableName || "";
    }

    // console.log("Sending Order:", orderData);

    try {
      const { data } = await axios.post(
        `${window.BASE_API_URL}order-validate`,
        orderData
      );

      if (data?.success) {
        setPaymentOrderId(data.order_id); // assume backend sends order_id
        setPaymentAmount(orderData.total);
        setShowPaymentModal(true);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.error("Order failed:", err);
      alert("❌ Failed to place order");
    }
  };

  return (
    <div className={`cart-modal-overlay ${isMobile ? "mobile" : "desktop"}`}>
      <div className={`cart-modal ${isMobile ? "mobile" : "desktop"}`}>
        <div className="text-2xl font-bold">Checkout</div>

        <button className="close-btn" onClick={onClose}>×</button>

        {orderType != 'dinein' &&
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-3 mt-4 flex justify-center gap-6 text-sm text-gray-800 font-medium">
              <div className="flex items-center gap-1">
                <svg className="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h18v4H3V3zM3 9h18v4H3V9zM3 15h18v4H3v-4z" />
                </svg>
                Pickup in {settings?.pickup_time} min
              </div>

              {settings?.is_delivery_off != 0 && <>
              <span className="text-gray-300">•</span>
              <div className="flex items-center gap-1">
                <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h18M3 8h18M3 13h18M3 18h18" />
                </svg>
                Delivery in {settings?.delivery_time} min
              </div>

              </> }
            </div>
          </div>}

        <br />

<div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4">
            Cart automatically clears in every 2 hours
          </div>
      <br/>

        {orderType != 'dinein' && minimumOrderValue > 0 && (
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4">
            Minimum order value for {orderType || "delivery"} is ${minimumOrderValue}
          </div>
        )}
        <br />

        {/* Cart Items */}
        {cartItems.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <div className="bg-white rounded shadow p-4">
            <h2 className="text-lg font-semibold mb-4">Order Details</h2>
            <div className="space-y-4">
              <ul className="cart-items">
                {cartItems.map((item, index) => (
                  <li key={item.id} className="cart-item">
                    <div className="cart-header">
                      <div onClick={() => toggleAccordion(index)} style={{width:"60%"}}>
                        <strong>{item.name} <br /> {item.type == 'free_item' && <span className="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded-full">
                          Offer Item
                        </span>}
                          {item.type == 'first_offer' && <span className="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded-full">
                            First Offer Item
                          </span>}

                          {item?.exclusion?.length > 0 && ( <>

  {item.exclusion.includes("Coupan") && item.exclusion.includes("SpecialDiscount") ? (
  <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded-full ml-2">
    Not eligible for coupon or special discount
  </span>
) : item.exclusion.includes("Coupan") ? (
  <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded-full ml-2">
    Coupon not applicable
  </span>
) : item.exclusion.includes("SpecialDiscount") ? (
  <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded-full ml-2">
    Special discount not applicable
  </span>
) : null}
  </>
)}
                        </strong>
                        <div style={{ fontSize: "14px", color: "#666" }}>
                          Qty: {item.quantity}
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <span>{localStorage.getItem('currency')} {Number(item.total).toFixed(2)}</span>

                        <button onClick={() => handleEdit(item)} className="icon-btn">✏️</button>
   <div className="relative">
  <button
    onClick={() =>
      setConfirmDeleteId(
        confirmDeleteId === item.id ? null : item.id
      )
    }
    className="icon-btn hover:text-red-600 transition"
  >
    🗑
  </button>

  {/* Tooltip */}
  {confirmDeleteId === item.id && (
    <DeleteTooltip
      onConfirm={() => {
        deleteItem(item.id);
        setConfirmDeleteId(null);
      }}
      onCancel={() => setConfirmDeleteId(null)}
    />
  )}
</div>


                        <span
                          onClick={() => toggleAccordion(index)}
                          className={`arrow ${expandedIndex === index ? "open" : ""}`}
                        >
                          ▼
                        </span>
                      </div>

 

                    </div>
                     {/* {confirmDeleteId === item.id && (
                      
  <div className="mt-2 flex gap-2 justify-end">
    <button
      onClick={() => {
        deleteItem(item.id);   // reuse existing logic
        setConfirmDeleteId(null);
      }}
      className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700"
    >
      Delete
    </button>

    <button
      onClick={() => setConfirmDeleteId(null)}
      className="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
    >
      Cancel
    </button>
  </div>
)} */}

                    {expandedIndex === index && (
                      <div className="cart-body">
                        {/* 🔹 If it's a combo, show its category + menu selections */}
                        {item.type === "combo" ? (
                          <div className="combo-details space-y-3">
                            {Object.entries(item.selections || {}).map(([catIdx, slotMap]) => (
                              <div
                                key={catIdx}
                                className="combo-category border rounded p-2 bg-gray-50"
                              >
                                <div className="font-semibold text-orange-700 mb-1">
                                  {slotMap?.categoryName ||
                                    `Category ${parseInt(catIdx) + 1}`}
                                </div>
                                <ul className="space-y-1 pl-3">
   {Object.values(slotMap?.items).map((menu, mi) => {
  const currency = localStorage.getItem("currency");

  return (
    <li key={mi} className="text-sm">

      {/* 🔹 Header (same as normal) */}
      <div className="flex justify-between items-center">
        <div>
          <span className="font-medium">{menu.name}</span>
          <span className="text-gray-500 ml-1">
            × {menu.quantity || 1}
          </span>
        </div>

        {/* FINAL PRICE */}
        <div className="text-gray-700">
          {currency} {(menu.total || 0).toFixed(2)}
        </div>
      </div>

      {/* 🔸 BASE PRICE (like normal item base) */}
      <div className="ml-3 text-xs text-gray-500">
        Base Price: {currency} {(menu.basePrice || 0).toFixed(2)}
      </div>

      {/* 🔸 GROUPED MODIFIERS (SAME AS NORMAL UI) */}
  {menu.groupedModifiers?.map((group, gi) =>
  group.groupType != 4 && (
    <div key={gi} className="modifier-group ml-3 mt-1">
      <div className="group-name text-xs font-semibold">
        {group.groupName}
      </div>

      {group.options.map((opt, oi) => (
        <div
          key={oi}
          className="modifier-option text-xs flex justify-between"
        >
          <span>
            {opt.name} ×{opt.quantity}
          </span>

          <span>
            {opt.price > 0 &&
              `${currency} ${(opt.price * opt.quantity).toFixed(2)}`}
          </span>
        </div>
      ))}
    </div>
  )
)}

      {/* 🔸 SPECIAL INSTRUCTION (same style) */}
      {menu.specialInstruction && (
        <div className="ml-3 text-xs text-gray-600 mt-1">
          <b>Special Instruction:</b> {menu.specialInstruction}
        </div>
      )}

    </li>
  );
})}
                                </ul>
                              </div>
                            ))}
                          </div>
                        ) : (
                          /* 🔸 Default (non-combo item) details */
                          item.selectedModifiers?.map((group, i) =>  group.groupType != 4 && (
                            <div key={i} className="modifier-group">
                              <div className="group-name">
                                <strong>{group.groupName}</strong>
                              </div>
                              {group.options.map((opt, j) => (
                                <div key={j} className="modifier-option">
                                  <span>{opt.name}</span>
                                  <span>x{opt.quantity}</span>
                                  <span> {localStorage.getItem('currency')} {(opt.price * opt.quantity).toFixed(2)}</span>
                                </div>
                              ))}
                            </div>
                          ))
                        )}

                        {item?.specialInstruction && 
                        <div style={{fontSize:"13px"}}>
                          <b>Special Instruction :</b> {item?.specialInstruction}
                        </div> }
                      </div>
                    )}

                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {orderType === "dinein" && dinein?.tableName && (
          <div className="bg-green-50 border border-green-300 rounded p-3 mt-3 text-green-800">
            🍽️ Dine-in Order • Table: <strong>{dinein.tableName}</strong>
          </div>
        )}


        {cartItems.length > 0 && orderType !== "dinein" && (
          <div className="bg-white rounded shadow p-4 mt-4">
            <h2 className="text-lg font-semibold mb-4">Order Type</h2>
            <div className="flex space-x-4 mb-4">

              {settings?.is_delivery_off == 1 &&
                <button
                  className={`flex-1 border rounded p-2 text-center font-semibold ${orderType === "delivery" ? "bg-black text-white" : "hover:bg-gray-100"}`}
                  onClick={() => setOrderType("delivery")}
                >
                  Delivery
                </button>}
              <button
                className={`flex-1 border rounded p-2 text-center font-semibold ${orderType === "pickup" ? "bg-black text-white" : "hover:bg-gray-100"}`}
                onClick={() => setOrderType("pickup")}
              >
                Pickup
              </button>
            </div>
          </div>)}


        {cartItems.length > 0 && orderType != 'dinein' && subtotal < minimumOrderValue && minimumOrderValue > 0 && (
          <div className=" text-red-700 p-4">
            Minimum order value for {orderType || "delivery"} is ${minimumOrderValue}
          </div>
        )}

        {cartItems.length > 0 && subtotal_before_discount >= minimumOrderValue ? <>

          {orderType != "dinein" && (<>


            {/* Order Timing */}
            <div className="bg-white rounded shadow p-4 mt-4">
              <h2 className="text-lg font-semibold mb-4">Order Timing</h2>
              <div className="space-y-3 order-timing">
                <label className="flex items-center space-x-2">
                  <input type="radio" name="orderTiming" checked={orderTiming === "now"} onChange={() => setOrderTiming("now")} />
                  <span className="font-semibold text-black-600">Order Now (ASAP)</span>
                </label>
                <span className="text-sm text-gray-500 ml-2">Ready in {readyText} minutes.</span>
                {settings?.is_close_advance_ordering != 1 &&
                  <label className="flex items-center space-x-2">
                    <input type="radio" name="orderTiming" checked={orderTiming === "later"} onChange={() => setOrderTiming("later")} />
                    <span className="font-semibold text-black-600">Schedule Later</span>

                  </label>}

                {settings?.is_close_advance_ordering != 1 &&
                  <span className="text-sm text-gray-500 ml-2">Choose your preferred date and time</span>
                }
                {orderTiming === "later" && (
                  <div className="space-y-4 mt-2">
                    <div>
                      <label className="block text-sm font-medium mb-1">
                        Select Date <span className="text-red-600">*</span>
                      </label>
<input
  type="date"
  className="border rounded p-2 w-full"
  value={scheduleDate}
  min={today}
  max={maxDate}
  onChange={(e) => {
    const selectedDate = e.target.value;

    if (!selectedDate) return;

    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    const pickedDate = new Date(selectedDate);
    pickedDate.setHours(0, 0, 0, 0);

    if (pickedDate < todayDate) {
      toast.error("❌ You cannot select a past date.");
      setScheduleDate(today);
      setScheduleTime("");
      return;
    }

    if (pickedDate > new Date(maxDate)) {
      toast.error(`❌ You can only schedule up to ${maxDate}`);
      setScheduleDate(maxDate);
      setScheduleTime("");
      return;
    }

    setScheduleDate(selectedDate);
  }}
/>


                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-1">
                        Select Time <span className="text-red-600">*</span>
                      </label>

                      {timeSlots.length > 0 ? (
                        <select
                          className="border rounded p-2 w-full"
                          value={scheduleTime}
                          onChange={(e) => setScheduleTime(e.target.value)}
                        >
                          <option value="">-- Select Time Slot --</option>
                          {timeSlots.map((slot, i) => (
                            <option key={i} value={slot}>
                              {slot} {/* show HH:mm only */}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <select
                          className="border rounded p-2 w-full"
                          value=""

                        >
                          <option value="">-- Select Time Slot --</option>

                        </select>
                      )}
                    </div>
                  </div>
                )}


                {orderType && orderStatus && (
                  <div className=" text-red-700 text-center">
                    {orderStatus}
                  </div>
                )}

              </div>
            </div>
          </>)}

{orderType === "delivery" && (
  <div className="bg-white rounded shadow p-4 mt-4">
    <h2 className="text-lg font-semibold mb-4">Saved Addresses</h2>

    {/* ➕ ADD NEW ADDRESS BUTTON */}
    <button
      onClick={() => {
        setEditingAddress(null);
        setNewAddress({
          hno: "",
          street_address: "",
          suburb: "",
          pincode: "",
          city: "",
          state: "",
          country: "AU",
        });
        setShowAddressPopup(true);
      }}
      className="w-full border-2 border-dashed border-gray-300 rounded-lg py-3 text-center text-gray-600 hover:bg-gray-50 mb-4"
    >
      ＋ Add New Address
    </button>

    {addresses.map((addr) => {
      const isDeliverable = settings?.delivery_type == 0
        ? zipcodes.includes(addr.pincode?.toString())
        : true;

      return (
        <div
          key={addr.id}
          className={`relative border rounded-lg p-4 mb-3 cursor-pointer ${
            selectedAddressId === addr.id
              ? "border-orange-400 bg-orange-50"
              : "border-gray-300"
          }`}
          onClick={() => setSelectedAddressId(addr.id)}
        >
          {/* Header */}
          <div className="flex justify-between items-center">
            <div className="text-orange-600 font-semibold">
              📍 {addr.label}
            </div>

            {isDeliverable ? (
              selectedAddressId === addr.id && (
                <span className="text-green-600 font-semibold">✔ Selected</span>
              )
            ) : (
              <span className="text-red-600 font-semibold bg-red-100 px-2 py-1 rounded">
                ❌ Not Deliverable
              </span>
            )}


              {!deliveryelegible && deliveryelegiblemessage &&  selectedAddressId === addr.id && deliveryelegiblemessage == 'address_undeliverable' && (
     <span className="text-red-600 font-semibold bg-red-100 px-2 py-1 rounded">
                ❌ Not Deliverable
              </span>
          )} 
          </div>

          {/* Details */}
          <div className="text-sm text-gray-700 mt-2 space-y-1">
            <div>
              <strong>🏠 {addr.hno}</strong>, {addr.street_address}
            </div>
            <div>
              {addr.suburb}, {addr.city} {addr.pincode}
            </div>
            <div>
              {addr.state}, {addr.country}
            </div>
          </div>

          <div className="text-xs text-gray-500 mt-1">Added {addr.addedAt}</div>

          {/* === EDIT & DELETE BUTTONS === */}
          <div className="absolute bottom-2 right-2 flex gap-3">

            {/* ✏️ EDIT */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setEditingAddress(addr);
                setNewAddress(addr);
                setShowAddressPopup(true);
              }}
              className="text-blue-600 hover:text-blue-800"
            >
              ✏️
            </button>

            {/* 🗑 DELETE */}
            <button
              onClick={async (e) => {
                e.stopPropagation();

                const confirm = await Swal.fire({
                  title: "Delete Address?",
                  text: "Are you sure you want to delete this address?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Delete",
                  cancelButtonText: "Cancel",
                });

                if (!confirm.isConfirmed) return;

                if (user?.id && token) {
                  const res = await axios.post(
                    `${window.BASE_API_URL}address/delete/${addr.id}`,
                    { token }
                  );

                  if (res.data.success) loadAddressesFromDB();
                } else {
                  const updated = addresses.filter((a) => a.id !== addr.id);
                  setAddresses(updated);
                  localStorage.setItem("addresses", JSON.stringify(updated));
                }

                toast.success("Address deleted");
              }}
              className="text-red-600 hover:text-red-800"
            >
              🗑️
            </button>
          </div>
        </div>
      );
    })}
  </div>
)}


          {((settings?.is_promo == 1) || (settings?.is_tips == 1 && tips.length > 0) || (settings?.is_gift_vouchers == 1) || (settings?.is_gift_vouchers == 1 && appliedVouchers.length > 0)) &&
            <div className="bg-white rounded shadow p-4 mt-4 testtt">
              <div className="space-y-3">

                {settings?.is_promo == 1 &&
                  <div className="flex gap-2 my-2">
                    <input
                      type="text"
                      className="border rounded p-2 flex-1"
                      placeholder="Enter Coupon Code"
                      value={couponCode}
                      disabled={!!appliedCoupon || grandTotal === 0}
                      onChange={(e) => setCouponCode(e.target.value)}
                    />
                    {!appliedCoupon ? (
                      <button
                        className="bg-green-600 text-white px-3 py-2 rounded disabled:opacity-50"
                        onClick={handleApplyCoupon}
                        disabled={grandTotal === 0}
                      >
                        Apply
                      </button>
                    ) : (
                      <button
                        className="bg-red-600 text-white px-3 py-2 rounded"
                        onClick={handleRemoveCoupon}
                      >
                        Remove
                      </button>
                    )}
                  </div>}

                {appliedCoupon ? (
                  <div className="text-green-700 text-sm mt-1">
                    ✅ Coupon "{appliedCoupon.promo_code}" applied
                  </div>
                ) : ''}

                {/* Gift Voucher Code */}

                {settings?.is_gift_vouchers == 1 &&
                  <div className="flex gap-2 my-2">
                    <input
                      type="text"
                      className="border rounded p-2 flex-1"
                      placeholder="Enter Gift Voucher Code"
                      value={giftVoucherCode}
                      onChange={(e) => setGiftVoucherCode(e.target.value)}
                      disabled={grandTotal === 0}
                    />
                    <button
                      className="bg-blue-600 text-white px-3 py-2 rounded"
                      onClick={handleApplyVoucher}
                      disabled={grandTotal === 0}

                    >
                      Apply
                    </button>
                  </div>}

                {/* Show applied vouchers list */}
                {(settings?.is_gift_vouchers == 1 && appliedVouchers.length > 0) ? (
                  <div className="bg-white rounded p-3 mt-2">
                    <div className="font-semibold mb-2">Applied Vouchers</div>
                    <ul className="space-y-2">
                      {appliedVouchers.map((v) => (
                        <li key={v.id} className="flex justify-between items-center">
                          <div style={{width:"55%"}}>
                            <div className="text-sm">{v.code}</div>
                            <div className="text-xs text-gray-500">Original: {localStorage.getItem('currency')} {v.original_amount.toFixed(2)} <br/> Remaining: {localStorage.getItem('currency')} {v.remaining_amount.toFixed(2)}</div>
                          </div>
                          <div className="flex items-center gap-2">
                            <div className="text-green-700">- {localStorage.getItem('currency')} {v.applied_amount.toFixed(2)}</div>
                            <button className="px-2 py-1 bg-red-100 rounded text-red-700" onClick={() => handleRemoveVoucher(v.id)}>X</button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : ''}


                {(settings?.is_tips == 1 && tips.length > 0) && (
                  <div className="bg-white rounded shadow p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-2">Add a Tip</h2>
                    <select
                      className="border rounded p-2 w-full"
                      value={selectedTip ? tips.indexOf(selectedTip) : ""}
                      onChange={(e) => setSelectedTip(tips[e.target.value])}
                    >
                      <option value="">-- Select Tip --</option>
                      {tips.map((tip, idx) => (
                        <option key={idx} value={idx}>
                          {tip.type === "F" ? `${localStorage.getItem('currency')} ${tip.amount}` : `${tip.amount}% of subtotal`}
                        </option>
                      ))}
                    </select>


                  </div>
                )}

              </div>

            </div>}

          {/* Guest Info if not logged in */}
       {/* Guest Info / Dine-in Info */}
{orderType === "dinein" ? (
  <>
    {/* CASE 1 → Do NOT show anything */}
    {settings?.user_dinein_info == 1 ? null : (
      <div className="bg-white rounded shadow p-4 mt-4">
        <h2 className="text-lg font-semibold mb-4">Your Details</h2>

        <div className="space-y-3">

          {/* CASE 0 → Show Name, Email, Phone */}
          {/* CASE 2 → Show ONLY Name */}
          {(settings?.user_dinein_info == 0 || settings?.user_dinein_info == 2) && (
            <input
              type="text"
              className="border rounded p-2 w-full"
              placeholder="Full Name"
              value={guestName}
              onChange={(e) => setGuestName(e.target.value)}
              required
            />
          )}

          {settings?.user_dinein_info == 0 && (
            <>
              <input
                type="email"
                className="border rounded p-2 w-full"
                placeholder="Email"
                value={guestEmail}
                onChange={(e) => setGuestEmail(e.target.value)}
                required
              />
              <input
                type="tel"
                className="border rounded p-2 w-full"
                placeholder="Phone Number"
                value={guestPhone}
                onChange={(e) => setGuestPhone(e.target.value)}
                required
              />
            </>
          )}

        </div>
      </div>
    )}
  </>
) : (
  /* Existing guest logic for non-dinein */
  (settings?.is_guest == 1 && !user && (
    <div className="bg-white rounded shadow p-4 mt-4">
      <h2 className="text-lg font-semibold mb-4">Your Details</h2>
      <div className="space-y-3">
        <input
          type="text"
          className="border rounded p-2 w-full"
          placeholder="Full Name"
          value={guestName}
          onChange={(e) => setGuestName(e.target.value)}
          required
        />
        <input
          type="email"
          className="border rounded p-2 w-full"
          placeholder="Email"
          value={guestEmail}
          onChange={(e) => setGuestEmail(e.target.value)}
          required
        />
        <input
          type="tel"
          className="border rounded p-2 w-full"
          placeholder="Phone Number"
          value={guestPhone}
          onChange={(e) => setGuestPhone(e.target.value)}
          required
        />
      </div>
    </div>
  ))
)}



          {/* Special Instructions */}
          <div className="bg-white rounded shadow p-4 mt-4">
            <h2 className="text-lg font-semibold mb-4">
              {orderType === "dinein"
                ? "Instructions"
                : orderType === "delivery"
                  ? "Delivery Instructions"
                  : "Pickup Instructions"}
            </h2>


            <textarea
              className="border rounded p-2 w-full"
              rows="3"
              placeholder={
                orderType === "delivery"
                  ? "Add delivery instructions (e.g., leave at door)..."
                  : "Add pickup instructions (e.g., call when ready)..."
              }
              value={specialInstruction}
              onChange={(e) => setSpecialInstruction(e.target.value)}
            />
          </div>


          {availablePaymentTypes.length > 1 && (
            <div className="bg-white rounded shadow p-4 mt-4">
              <h2 className="text-lg font-semibold mb-4">Payment Method</h2>
              <div className="flex space-x-4">
                {availablePaymentTypes.includes("cash") && (
                  <button
                    className={`flex-1 border rounded p-2 text-center font-semibold ${paymentType === "cash"
                      ? "bg-green-500 text-white"
                      : "hover:bg-green-100"
                      }`}
                    onClick={() => setPaymentType("cash")}
                  >
                    Cash
                  </button>
                )}

                {availablePaymentTypes.includes("cashoncollection") && (
                  <button
                    className={`flex-1 border rounded p-2 text-center font-semibold ${paymentType === "cashoncollection"
                      ? "bg-green-500 text-white"
                      : "hover:bg-green-100"
                      }`}
                    onClick={() => setPaymentType("cashoncollection")}
                  >
                    Cash
                  </button>
                )}
                {availablePaymentTypes.includes("card") && (
                  <button
                    className={`flex-1 border rounded p-2 text-center font-semibold ${paymentType === "card"
                      ? "bg-blue-500 text-white"
                      : "hover:bg-blue-100"
                      }`}
                    onClick={() => setPaymentType("card")}
                  >
                    Enter Card
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Rewards Section */}
          {settings?.is_rewards == "1" && userRewards > 0 && (
            <div className="my-3">
              {/* Label */}
              <div className="text-green-700 text-sm mt-4 text-center mb-2">
                🎉 You have {userRewards} reward points available
                <br />
                You can use {settings?.rewards_redeem_per}% of Order Amount upto {settings?.rewards_redeem_max} ({localStorage.getItem('currency')} {(Number(settings.rewards_point_value) / Number(settings.rewards_point) * settings?.rewards_redeem_max)}) rewards points
              </div>

              <div className="flex gap-2">
                <input
                  type="number"
                  className="border rounded p-2 flex-1"
                  placeholder={`Enter reward points (max ${userRewards})`}
                  value={redeemPoints}
                  onChange={(e) => setRedeemPoints(e.target.value)}
                  disabled={!!appliedRewards}
                />

                {!appliedRewards ? (
                  <button
                    className="bg-purple-600 text-white px-3 py-2 rounded disabled:opacity-50"
                    onClick={handleApplyRewards}
                  // disabled={grandTotal === 0}
                  >
                    Apply
                  </button>
                ) : (
                  <button
                    className="bg-red-600 text-white px-3 py-2 rounded"
                    onClick={handleRemoveRewards}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Show applied rewards */}
          {appliedRewards && (
            <div className="text-green-700 text-sm mt-1">
              ✅ {appliedRewards.points} points applied (− {localStorage.getItem('currency')} {appliedRewards.value.toFixed(2)})
            </div>
          )}

          {isEligibleForFreeItem && (
            <div className="text-green-700 text-sm mt-4 text-center">
              🎉 You are eligible for a offer item.{" "}
              <button
                onClick={onViewFreeItem}
                className="text-green-800 font-semibold underline hover:text-green-900 transition"
              >
                Click here to add your offer item
              </button>
            </div>
          )}


          {/* Order Summary (driven by API) */}
          <div className="bg-white rounded shadow p-4 mt-4">
            <h2 className="text-lg font-semibold mb-2">Order Summary</h2>

            <div className="flex justify-between">
              <span>Subtotal</span>
              <span> {localStorage.getItem('currency')} {subtotal_before_discount.toFixed(2)}</span>
            </div>

            {appliedCoupon && (
              <div className="flex justify-between text-green-700">
                <span>
                  Coupon ({appliedCoupon.promo_code})
                  {appliedCoupon.discount_type === "P" ? ` (${appliedCoupon.discount}%  of ${round2(subtotal_coupon_allowed)})` : ""}
                </span>
                <span>- {localStorage.getItem('currency')} {couponTotal.toFixed(2)}</span>
              </div>
            )}

            {(charges.special || []).map((s) => (
              <div key={s.id} className="flex justify-between text-green-700">
                <span>
                 {s.label ? s.label :  'Discount' }{s.discount_type === "P" ? ` (${parseFloat(s.discount) || 0}% of ${round2(subtotal_special_allowed)})` : ""}
                </span>
                <span>- {localStorage.getItem('currency')} {calcDiscountAmount(s).toFixed(2)}</span>
              </div>
            ))}


            {(charges.tax || []).map((t) => (
              <div key={t.id} className="flex justify-between">
                <span>{t.label || "Tax"} ({parseFloat(t.tax) || 0}%)</span>
                <span>{localStorage.getItem('currency')} {calcTaxAmount(t).toFixed(2)}</span>
              </div>
            ))}



            {(charges.additional || []).map((a) => (
              <div key={a.id} className="flex justify-between">
                <span>
                  {a.label || "Additional"}{a.type === "P" ? ` (${parseFloat(a.charge) || 0}%)` : ""}
                </span>
                <span>{localStorage.getItem('currency')} {calcAdditionalAmount(a).toFixed(2)}</span>
              </div>
            ))}



            {selectedTip && (

              <div className="flex justify-between">
                <span>
                  Tips
                </span>
                <span>{localStorage.getItem('currency')} {tipAmount.toFixed(2)}</span>
              </div>
            )}

            
            {/* Vouchers */}
            {appliedVouchers.map((v) => (
              <div key={v.id} className="flex justify-between text-green-700">
                <span>Voucher ({v.code})</span>
                <span>- {localStorage.getItem('currency')}{Number(v.applied_amount).toFixed(2)}</span>
              </div>
            ))}

            {appliedRewards && (
              <div className="flex justify-between text-green-700">
                <span>Rewards ({appliedRewards.points} pts)</span>
                <span>- {localStorage.getItem('currency')}{appliedRewards.value.toFixed(2)}</span>
              </div>
            )}


            <div className="flex justify-between font-bold border-t pt-2 mt-2">
              <span>Total</span>
              <span>{localStorage.getItem('currency')} {grandTotal > 0 ? grandTotal.toFixed(2): 0.00}</span>
            </div>

                      {isInclusiveTax && (
  <div className="flex justify-between text-gray-600 text-sm">
    <span>
      {settings?.tax_label || "Tax"} ({settings?.tax_value}%)
    </span>
    <span>
      {localStorage.getItem("currency")} {inclusiveTaxAmount.toFixed(2)}
    </span>
  </div>
)}


          </div>





          {settings?.is_rewards_sent == 1 && user?.id && (
            <div className="text-green-700 text-sm mt-4 text-center mb-2">
              {(() => {
                // Determine earned points based on config
                const earnedPoints =
                  settings?.rewards_based == 1
                    ? subtotal / settings.rewards_point_per
                    : grandTotal / settings.rewards_point_per;

                const applyamount =
                  settings?.rewards_based == 1
                    ? subtotal
                    : grandTotal;

                // Cap at remaining limit
                const currentPoints = Number(userRewards || 0);
                const maxPoints = Number(settings?.rewards_max || 0);
                const remainingAllowed = Math.max(maxPoints - currentPoints, 0);
                const displayPoints = Math.min(earnedPoints, remainingAllowed);
                if (applyamount > Number(settings?.rewards_min_order || 0)) {
                  return (
                    <span>
                      {displayPoints > 0 ? (
                        <>
                          🎉 You will earn{" "}
                          <strong className="text-emerald-600">
                            {displayPoints.toFixed(2)} pts
                          </strong>{" "}
                          on this order
                        </>
                      ) : (
                        <span className="text-gray-500">
                          🏆 You’ve already reached your max reward limit ({maxPoints} pts)
                        </span>
                      )}
                    </span>
                  );
                }
              })()}
            </div>
          )}

     

          {orderStatus && (
            <>
                 <br />
            <div className=" text-red-700 text-center">
              {orderStatus}
            </div>

            </>
          )}

    {settings?.is_branch_off == 1 && (
      <>
      
          <br />
            <div className=" text-red-700 text-center">
             You are ordering from {settings?.home_branch_location}
            </div>

            </>
          )}
           {!deliveryelegible && deliveryelegiblemessage && deliveryelegiblemessage != 'address_undeliverable' &&(
            <>
    <br />
            <div className=" text-red-700 text-center">
            {deliveryelegiblemessage}
            </div>

            </>
          )} 
        
          
          { (settings?.is_guest == 1  || (orderType === "dinein" && dinein?.tableName)) ? (

<>

{(orderType === "dinein" && dinein?.tableName) ?  <>

    {settings?.is_dinein_order == 1 ? (
   <button
              onClick={handlePlaceOrder}
              disabled={(!paymentType || orderStatus != '') ? true : false}
              className={`w-full py-3 rounded-lg font-bold ${(!paymentType || orderStatus != '')
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-orange-600 hover:bg-orange-700 text-white"
                }`}
                style={
    !paymentType || orderStatus !== ""
      ? {} // ❌ No custom style when disabled
      : {
          background: settings?.cart_btn_color || "#000000ff",
          color: settings?.cart_btn_text_color || "#ffffff",
          cursor: "pointer",
        }
  }
  onMouseEnter={(e) => {
    if (!(!paymentType || orderStatus !== "")) {
      e.currentTarget.style.background =
        settings?.cart_btn_hover || "#f59e0b";
    }
  }}
  onMouseLeave={(e) => {
    if (!(!paymentType || orderStatus !== "")) {
      e.currentTarget.style.background =
        settings?.cart_btn_color || "#000000ff";
    }
  }}
            >
              Place Order
            </button> 
) : (
  <span className="inline-flex items-center px-3 py-1 text-sm font-semibold text-red-700 bg-red-100 rounded-full">
    🔴 We are not accepting orders
  </span>
)}
          
            </>
            :   <button
              onClick={handlePlaceOrder}
              disabled={(!paymentType || orderStatus != '') ? true : false}
              className={`w-full py-3 rounded-lg font-bold ${(!paymentType || orderStatus != '')
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-orange-600 hover:bg-orange-700 text-white"
                }`}
       style={
    !paymentType || orderStatus !== ""
      ? {} // ❌ No custom style when disabled
      : {
          background: settings?.cart_btn_color || "#000000ff",
          color: settings?.cart_btn_text_color || "#ffffff",
          cursor: "pointer",
        }
  }
  onMouseEnter={(e) => {
    if (!(!paymentType || orderStatus !== "")) {
      e.currentTarget.style.background =
        settings?.cart_btn_hover || "#f59e0b";
    }
  }}
  onMouseLeave={(e) => {
    if (!(!paymentType || orderStatus !== "")) {
      e.currentTarget.style.background =
        settings?.cart_btn_color || "#000000ff";
    }
  }}
            >
              Place Order
            </button> }

            </>
          ) : (
            <div>
              {user?.id ? (
                <button
                  onClick={handlePlaceOrder}
                  style={
    !paymentType || orderStatus !== ""
      ? {} // ❌ No custom style when disabled
      : {
          background: settings?.cart_btn_color || "#000000ff",
          color: settings?.cart_btn_text_color || "#ffffff",
          cursor: "pointer",
        }
  }
  onMouseEnter={(e) => {
    if (!(!paymentType || orderStatus !== "")) {
      e.currentTarget.style.background =
        settings?.cart_btn_hover || "#f59e0b";
    }
  }}
  onMouseLeave={(e) => {
    if (!(!paymentType || orderStatus !== "")) {
      e.currentTarget.style.background =
        settings?.cart_btn_color || "#000000ff";
    }
  }}
                  disabled={(!paymentType || orderStatus != '') ? true : false}
                  className={`w-full py-3 rounded-lg font-bold ${(!paymentType || orderStatus != '')
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-orange-600 hover:bg-orange-700 text-white"
                    }`}
                >
                  Place Order
                </button>
              ) : (
                <> {localStorage.getItem('apptype') != 'app' && 
                <div className="flex gap-2 mt-4">
                  <button
                    onClick={openLogin}
                    className="bg-orange-500 text-white w-full py-3 rounded-lg font-bold"
                  >
                    Login
                  </button>

                  <button
                    onClick={openRegister}
                    className="bg-orange-500 text-white w-full py-3 rounded-lg font-bold"
                  >
                    Register
                  </button>
                </div>
              }
              </>
              )}
            </div>
          )}

        </> :
          ''

        }



      </div>


      {showAddressPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-h-[90vh] overflow-y-auto">
          <h3 className="text-lg font-semibold mb-3">
  {editingAddress ? "Edit Address" : "Add New Address"}
</h3>


{settings?.delivery_type == 1 ? (
  <>
    <AddressAutocomplete
      apiKey={settings?.map_api}
      onSelect={(parsed) => setNewAddress((prev) => ({ ...prev, ...parsed }))}
    />
    <div className="mt-3 text-sm text-gray-700 space-y-1">
      <div><strong>Street:</strong> {newAddress.street_address}</div>
      <div><strong>Suburb:</strong> {newAddress.suburb}</div>
      <div><strong>City:</strong> {newAddress.city}</div>
      <div><strong>Pincode:</strong> {newAddress.pincode}</div>
      {/* <div><strong>Lat/Lng:</strong> {newAddress.latitude && `${newAddress.latitude}, ${newAddress.longitude}`}</div> */}
    </div>
  </>
) : (
  /* keep your existing manual inputs (House No, Street, etc.) */


            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium mb-1">
                  House / Flat No <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  name="hno"
                  placeholder="House / Flat No"
                  className="border rounded p-2 w-full"
                  value={newAddress.hno || ""}
                  onChange={(e) => setNewAddress({ ...newAddress, hno: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Street Name <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  name="street_address"
                  placeholder="Street Name"
                  className="border rounded p-2 w-full"
                  value={newAddress.street_address || ""}
                  onChange={(e) => setNewAddress({ ...newAddress, street_address: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Suburb 
                </label>
                <input
                  type="text"
                  name="suburb"
                  placeholder="Suburb"
                  className="border rounded p-2 w-full"
                  value={newAddress.suburb || ""}
                  onChange={(e) => setNewAddress({ ...newAddress, suburb: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Postcode <span className="text-red-600">*</span>
                </label>
                <input
                  type="number"
                  name="pincode"
                  placeholder="Postcode"
                  className="border rounded p-2 w-full"
                  value={newAddress.pincode || ""}
                  onChange={(e) => setNewAddress({ ...newAddress, pincode: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">City</label>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  className="border rounded p-2 w-full"
                  value={newAddress.city || ""}
                  onChange={(e) => setNewAddress({ ...newAddress, city: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  State <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  name="state"
                  placeholder="State"
                  className="border rounded p-2 w-full"
                  value={newAddress.state || ""}
                  onChange={(e) => setNewAddress({ ...newAddress, state: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Country</label>
                <input
                  type="text"
                  name="country"
                  placeholder="Country"
                  className="border rounded p-2 w-full"
                  value={newAddress.country || "AU"}
                  onChange={(e) => setNewAddress({ ...newAddress, country: e.target.value })}
                />
              </div>
            </div>

            )}

            <div className="flex justify-end gap-3 mt-4">
              <button
                className="px-4 py-2 rounded bg-gray-200"
                onClick={() => setShowAddressPopup(false)}
              >
                Cancel
              </button>
              <button
              style={{
  background: settings?.cart_btn_color || "#000000ff",
   color: settings?.cart_btn_text_color || "#ffffff",
}}
onMouseEnter={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_hover || "#f59e0b";
}}
onMouseLeave={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_color || "#ffffff";
}} 
                className="px-4 py-2 rounded bg-orange-500 text-white"
                onClick={handleAddAddress}
              >
                Save
              </button>
            </div>
          </div>
        </div>)}

      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        orderId={paymentOrderId}
        amount={paymentAmount}
        onSuccess={handlePaymentSuccess}
        paymentType={paymentType}
        orderType={orderType}
        key={paymentOrderId}
      />
    </div>
  );
};

export default CartModal;
